import React, { useRef, useEffect } from "react";
import { useLocation, Switch } from "react-router-dom";
import AppRoute from "./utils/AppRoute";
import ScrollReveal from "./utils/ScrollReveal";
import ReactGA from "react-ga";

// Layouts
import LayoutDefault from "./layouts/LayoutDefault";

// Views
import Home from "./views/Home";
import Contact from "./views/contact-us/Contact";
import AboutUs from "./views/about-us/AboutUs.js";
import Audit from "./views/services/Audit";
import Installation from "./views/services/Installation";
import Reporting from "./views/Reporting";
import Faq from "./views/Faq";
import EnergyEvaluation from "./views/services/EnergyEvaluation";
import Methods from "./views/Methods";
import Baseline from "./views/services/Baseline";
import MarketResearch from "./views/MarketResearch";
import Analytics from "./views/services/Analytics";
import EconomicImpacts from "./views/services/EconomicImpact";
import References from "./views/services/References";
import EnergyAuditsSignup from "./views/services/EnergyAudits";
import EnergyAuditsForm from "./views/services/EnergyAuditsForm";
import EnergyAuditsPrices from "./views/services/EnergyAuditsPrices";
import DirectInstallProgram from "./views/services/DirectInstallProgram";
import ResidentialEnergyAssessments from "./views/services/ResidentialEnergyAssessments";
import Services from "./views/services/Services";
import EnergyEfficiencyMeasures from "./views/EnergyEfficiencyMeasures";
import CeedContactUs from "./views/ceed-contact-us/CeedContactUs";
import PrivacyPolicy from "./views/privacy-policy/PrivacyPolicy";

// Initialize Google Analytics
ReactGA.initialize(process.env.REACT_APP_GA_CODE);

const trackPage = page => {
  ReactGA.set({ page });
  ReactGA.pageview(page);
};

const App = () => {
  const childRef = useRef();
  let location = useLocation();

  useEffect(() => {
    const page = location.pathname;
    document.body.classList.add("is-loaded");
    childRef.current.init();
    trackPage(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <ScrollReveal
      ref={childRef}
      children={() => (
        <Switch>
          <AppRoute exact path="/" component={Home} layout={LayoutDefault} />
          <AppRoute
            exact
            path="/contact-us"
            component={Contact}
            layout={LayoutDefault}
          />
           <AppRoute
            exact
            path="/ceed-contact-us"
            component={CeedContactUs}
            layout={LayoutDefault}
          />
          <AppRoute
            exact
            path="/about-us"
            component={AboutUs}
            layout={LayoutDefault}
          />
          <AppRoute
            exact
            path="/services/audits"
            component={Audit}
            layout={LayoutDefault}
          />
          <AppRoute
            exact
            path="/services/installations"
            component={Installation}
            layout={LayoutDefault}
          />
          <AppRoute exact path="/faq" component={Faq} layout={LayoutDefault} />
          <AppRoute
            exact
            path="/services"
            component={Services}
            layout={LayoutDefault}
          />
          <AppRoute
            exact
            path="/services/verification-services"
            component={EnergyEvaluation}
            layout={LayoutDefault}
          />
          <AppRoute
            exact
            path="/services/baseline"
            component={Baseline}
            layout={LayoutDefault}
          />
          <AppRoute
            exact
            path="/services/analytics"
            component={Analytics}
            layout={LayoutDefault}
          />
          <AppRoute
            exact
            path="/services/economic-impacts"
            component={EconomicImpacts}
            layout={LayoutDefault}
          />
          <AppRoute
            exact
            path="/services/references"
            component={References}
            layout={LayoutDefault}
          />
          <AppRoute
            exact
            path="/services/energy-assessments"
            component={Audit}
            layout={LayoutDefault}
          />
          <AppRoute
            exact
            path="/services/energy-assessments-signup"
            component={EnergyAuditsSignup}
            layout={LayoutDefault}
          />
          <AppRoute
            exact
            path="/services/energy-assessments-signup/form"
            component={EnergyAuditsForm}
            layout={LayoutDefault}
          />
          <AppRoute
            exact
            path="/services/energy-assessments-signup/pricing"
            component={EnergyAuditsPrices}
            layout={LayoutDefault}
          />
          <AppRoute
            exact
            path="/services/direct-install-program"
            component={DirectInstallProgram}
            layout={LayoutDefault}
          />
          <AppRoute
            exact
            path="/services/residential-energy-assessments"
            component={ResidentialEnergyAssessments}
            layout={LayoutDefault}
          />
          <AppRoute
            exact
            path="/energy-efficiency-measures"
            component={EnergyEfficiencyMeasures}
            layout={LayoutDefault}
          />
           <AppRoute
            exact
            path="/privacy-policy"
            component={PrivacyPolicy}
            layout={LayoutDefault}
          />
          
          <AppRoute path="*" component={Home} layout={LayoutDefault} />
        </Switch>
      )}
    />
  );
};

export default App;
